import { forwardRef, useCallback, useMemo } from "react";
import { Col, Dropdown, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { toastConfig } from "../../redux/actions/toast";
import { selectScripForDelete, updateActiveWatchlist, updateOpenWatchlist, updatedDashboardWatchlist } from "../../redux/actions/watchlist";
import { deepClone, getAppInfoData, returnCountWithPad, WATCHLIST_GRID_REF } from "../../utils/global_functions";
import { APP_INFO_DEFAULT_VALUES, APP_INFO_PARAMS, DONT_MISS_WATCHLIST_NAME, MY_HOLDINGS_WATCHLIST_NAME, } from "../../utils/global_variables";
import { useRightClick } from "../../hooks";

const CustomDropdownToggle = forwardRef(({ children, onClick }, ref) => (
    <div
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
    </div>
));



const WatchlistDropdown = (props) => {
    // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start 
    const { setIsExpanded, setIsSideBar, setIsGlobalSearch, handleAllFunctions,
        setScripDetails, show, setShow,
        children, setBIsShowDeleteCheckBox, setBIsShowSortHandle, setBisReordered, } = props;
    // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End 

    const { activeWatchList, openWatchlists, watchlists } = useSelector(state => state.watchList);
    const isLoadingUpdateWatchlist = useSelector(state => state.watchList.isLoadingUpdateWatchlist);
    const { appInfo } = useSelector(state => state.appInfo);
    const dispatch = useDispatch();

    const maxWatchlistLength = useMemo(() => getAppInfoData(APP_INFO_PARAMS.APP_MAX_PROFILE_COUNT, APP_INFO_DEFAULT_VALUES.APP_MAX_PROFILE_COUNT), []);

    // Ameersha N | BT-95888 Create Watchlist Feature start
    const arrWatchlistDropdown = useMemo(() => {
        const watchlistsCopy = deepClone(watchlists);

        if (watchlistsCopy && watchlistsCopy?.length > 0) {
            return watchlists;
        } else {
            return [];
        }
    }, [watchlists]);
    // Ameersha N | BT-95888 Create Watchlist Feature end

    const onSelectWatchlistDropdown = useCallback((objWatchlist, e) => {
        e.preventDefault();
        setIsExpanded(prev => { return { ...prev, containerLength: '0%' }; });
        setIsSideBar(false);
        setIsGlobalSearch(false);
        handleAllFunctions('HANDLE_IS_TOAST_MESSAGE', false);
        if (openWatchlists && openWatchlists.length > 0) {
            const arrOpenWatchlists = openWatchlists;
            const nIndex = openWatchlists.findIndex(watchList => watchList.id === objWatchlist.id);
            if (nIndex === -1) {
                const nCurrentActiveInOpenWatchlistIndex = openWatchlists.findIndex(watchList => watchList.id === activeWatchList.id);
                arrOpenWatchlists[nCurrentActiveInOpenWatchlistIndex] = objWatchlist;
                dispatch(updateOpenWatchlist([...arrOpenWatchlists]));
                dispatch(updateActiveWatchlist({ ...objWatchlist }));
                setTimeout(() => {
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: `${objWatchlist?.sWatchListName} (${returnCountWithPad(objWatchlist?.scrips?.length)}) has been added to the view`, }));

                }, 100);
                // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---Start 

                setBIsShowDeleteCheckBox(false);
                setBIsShowSortHandle(false);
                setBisReordered(false);
                dispatch(selectScripForDelete([]));
                // Azeem K : 16-11-2023 :BT-109055 : Breeze- Watchlist - Price Volume View  ---End 

            } else { }
        } else {
            dispatch(updateOpenWatchlist([objWatchlist]));
            dispatch(updateActiveWatchlist({ ...objWatchlist }));

        }
        setScripDetails([]);
        handleAllFunctions('HANDLE_MANAGE_COLUMNS', objWatchlist);
        dispatch(updateActiveWatchlist({ ...objWatchlist }));
        dispatch(updatedDashboardWatchlist({ ...objWatchlist })); //Vaibhav Singh: 08-09-2023 : Update Dashboard Watchlist
        handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF);
    }, [dispatch, handleAllFunctions, setScripDetails, openWatchlists, activeWatchList,
        setBIsShowDeleteCheckBox, setIsExpanded, setIsGlobalSearch, setIsSideBar, setBIsShowSortHandle]);
    // Ameersha N | BT-95888 Create Watchlist Feature end

    // Ameersha N | BT-95888 Create Watchlist Feature start
    const handleToggle = useCallback(() => {
        setShow(false);
    }, [setShow]);
    // Ameersha N | BT-95888 Create Watchlist Feature end


    const [targetElement] = useRightClick(handleToggle);

    return (
        <div className='watchlist-setdefault-tab-wrap me-3' ref={targetElement}>
            <Dropdown id="dropdown" className='p-0' show={show} onToggle={prev => setShow(prev)}>
                <Dropdown.Toggle className='p-0' as={CustomDropdownToggle}>
                    {children}
                </Dropdown.Toggle>
                <Dropdown.Menu className='py-0'>
                    <div className='dropdown-menu-body'>
                        {
                        arrWatchlistDropdown.map((each, index) => (
                            <Dropdown.Item data-testid={`watchlist-tabgroup-tab-dropdownitem-${index}`} as={({ children, className, onClick }) => <div onClick={onClick} className={className}>{children}</div>} onClick={onSelectWatchlistDropdown.bind(this, each)} key={each?.id}
                                className={` ${isLoadingUpdateWatchlist ? 'disabled' : ''}`} >
                                <Row className='g-0 align-items-center'>
                                    <Col data-testid={`watchlist-tabgroup-tab-dropdownitem-${index}`} md={7} className='d-flex justify-content-start align-items-center'>
                                        <div data-testid={`watchlist-tabgroup-tab-dropdownitem-watchlisttitle`} className='text-wrap'> {each?.sWatchListName?.length > 12 ? `${each?.sWatchListName.slice(0, 12)}...` : each?.sWatchListName} ({returnCountWithPad(each?.scrips?.length)}) </div>
                                    </Col>
                                    <Col data-testid={`watchlist-tabgroup-tab-dropdownDefaultitem-${index}`} md={5} className='d-flex justify-content-end align-items-center gap-2'>
                                        {each?.bIsDefault || each?.sWatchListName?.toLowerCase() === DONT_MISS_WATCHLIST_NAME || each?.sWatchListName?.toLowerCase() === MY_HOLDINGS_WATCHLIST_NAME ? <div className={each?.bIsDefault ? 'icon-16 icon-checktick icon-primary flex-shrink-0' : null}></div> : <div data-testid={`watchlist-tabgroup-tab-dropdownitem-watchlistdelete-button`} className='icon-16 icon-delete icon-dark flex-shrink-0' onClick={(e) => handleAllFunctions('DELETE_WATCHLIST', each, e, true)}></div>}
                                        {each?.bIsDefault ? <div className='font-medium font-size2 color-text p-t-3'>Default</div> : <div data-testid={`watchlist-tabgroup-tab-dropdownitem-watchlistdefault-button-${index}`} className='font-medium font-size2 color-primary p-t-3' onClick={(e) => handleAllFunctions('SET_DEFAULT', each, e, false)}>Set Default</div>}
                                    </Col>
                                </Row>
                            </Dropdown.Item>
                        ))
                    }
                    </div>
                    <div className='d-flex align-items-center dropdown-item gap-2 bdr-top' onClick={() => { handleAllFunctions('ON_RESET_WATCHLIST_GRID_FEATURES', WATCHLIST_GRID_REF); handleAllFunctions('HANDLE_CREATE_NEWWATCHLIST_OPTION'); }}>
                        <div className='icon-16 icon-add icon-primary flex-shrink-0'></div>
                        <div data-testid={`watchlist-tabgroup-tab-dropdownitem-createnewatchlist-button`} className='font-medium font-size2 color-primary cursor-pointer p-t-2'>Create New Watchlist ({watchlists?.length} /{maxWatchlistLength})</div>
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default WatchlistDropdown;
